export default [
  {
    type: 'STRING',
    name: 'name',
    defaultName: 'Name',
  },
  {
    type: 'STRING',
    name: 'description',
    defaultName: 'Description',
  },
  {
    type: 'STRING',
    name: 'owner',
    defaultName: 'Owner',
  },
  {
    type: 'STRING',
    name: 'id',
    defaultName: 'Id',
  },
  {
    type: 'DATETIME',
    name: 'created',
    defaultName: 'Created',
  },
  {
    type: 'DATETIME',
    name: 'updated',
    defaultName: 'Updated',
  },
  {
    type: 'BOOLEAN',
    name: 'deleted',
    defaultName: 'Deleted',
  },
  {
    type: 'INT',
    name: 'version',
    defaultName: 'Version',
  },
  {
    type: 'STRING',
    name: 'members',
    defaultName: 'Members',
  },
  {
    type: 'LISTOFSTRINGS',
    name: 'invitees',
    defaultName: 'Invitees',
  },
  {
    type: 'LISTOFSTRINGS',
    name: 'admins',
    defaultName: 'Admins',
  },
  {
    type: 'LISTOFSTRINGS',
    name: 'writers',
    defaultName: 'Writers',
  },
  {
    type: 'DICTSTRING_NUM',
    name: 'config',
    defaultName: 'Config',
  },
  {
    type: 'LISTOFSTRINGS',
    name: 'readers',
    defaultName: 'Readers',
  },
  {
    type: '',
    name: 'membershipRequests',
    defaultName: 'Membership Requests',
  },
  {
    type: 'STRING',
    name: 'state',
    defaultName: 'State',
  },
  {
    type: 'STRING',
    name: 'contentHouseProfileImage',
    defaultName: 'Content House Profile Image',
  },
]
